import React, { useEffect, useRef, useState } from "react";
import {FileText, MinusCircle, Plus, Search} from "react-feather";
import { FaSearch } from "react-icons/fa";
import {useDispatch, useSelector} from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {getBulkDropdownData, getOtherRefSearchDropdown} from "../../api/keyvalue";
import Grid from "../../components/Grid";
import LoadingSpinner from "../../components/LoadingSpinner";
import Tab from "../../components/Tab";
import Button from "../../components/input/Button";
import Dropdown from "../../components/input/Dropdown";
import Input from "../../components/input/Input";
import SideDrawer from "../../components/input/SideDrawer";
import {
  ActiveCellStyle, DateTimeCellRenderer, IssueStatusCellStyle,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../../components/renderer/StyleRenderer";
import { FORMS, MODULES } from "../../const";
import useUserCompany from "../../hooks/useUserCompany";
import WorkOrderForm from "../../components/fleet/WorkOrderForm";
import {workOrderById, addWorkOrder, updateWorkOrder, searchWorkOrderData} from "../../api/workOrderApi";
import { addAndUpload } from "../../api/documentUpload";
import { toast } from "react-toastify";
import SearchDropdown from "../../components/input/SearchDropdown";
import {errorActions} from "../../store/error-slice";
import { getTags } from "../../api/tagApi";
import { addAuditRecord } from "../../api/auditApi";
import { formatCsvDate } from "../../dateConfig";
import {workOrderCreationValidation} from "../../components/validations/WorkOrderCreation";
import Modal from "../../components/Modal";
import IssueStatusManagement from "../../components/fleet/IssueStatusManagement";
import WorkOrderStatusManagement from "../../components/fleet/WorkOrderStatusManagement";
const FORM = FORMS.FLEET.INFO.form;
const WorkOrder = () => {
  const location = useLocation();
  const errorState = useSelector((state) => state.error.workOrderErrors);
  const user = useSelector((state) => state.user);
  const auth = useSelector((state) => state.user.permissions[MODULES.Fleet]);
  const workOrderPermissions = auth?.[FORMS.FLEET_WORK_ORDER.WORK_ORDER.form];
  const downloadPermission = workOrderPermissions?.FORM?.DOWNLOAD;
  const closePermission = auth?.FLEET_WORK_ORDER?.FORM?.CLOSED;
  const userCompany = useUserCompany();
  const dispatch = useDispatch();
  const { pathname } = location;
  const [drawerTab, setDrawerTab] = useState(1);
  const [tab, setTab] = useState(1);
  const gridRef = useRef(null);
  const statusModalRef = useRef(null);
  const [selectedStatusData, setSelectedStatusData] = useState(null);

  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [resetVisible, setResetVisible] = useState(false);
  const [activeAccordion1, setActiveAccordion1] = useState(true);
  const [searchClicked, setSearchClicked] = useState(false);
  const [isSearchResultsPending, setIsSearchResultsPending] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editWorkOrder, setEditWorkOrder] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [isDownloadVisible, setIsDownloadVisible] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  // tab ref
  const workOrderRef = useRef();

  const [company, setCompany] = useState(
      userCompany ? userCompany.comId : null,
  );
  // Search Fields
  const [workOrderNumber, setWorkOrderNumber] = useState("");
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [status, setStatus] = useState(2);
  const [active, setActive] = useState(1);
  const [labels, setLabels] = useState([]);
  const [searchReset, setSearchReset] = useState(false);

  const [statusOpt, setStatusOpt] = useState([]);
  const [activeOpt, setActiveOpt] = useState([]);
  const [tagOptions, setTagOptions] = useState([]);

  // Mock ID for edit
  const [woId, setWoId] = useState("");
  const [woCode, setWoCode] = useState("");

  const handleAccordionClick1 = () => {
    setActiveAccordion1(!activeAccordion1);
  };

  useEffect(() => {
    handleReset();
  }, [pathname]);

  useEffect(() => {
    const aWeekAgo = new Date();
    aWeekAgo.setDate(aWeekAgo.getDate() - 7);
    const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
    const formattedToday = new Date().toISOString().split("T")[0];
    setFromDate(formattedWeekAgo);
    setToDate(formattedToday);
  }, []);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const {
        service_status,
        active,
      } = await getBulkDropdownData([
        { key: "service_status" },
        { key: "active" },
      ]);

      setStatusOpt(service_status || []);
      setActiveOpt(active || []);
      console.log("service_status",service_status)
      
      try {
        const tags = await getTags();
        const formatted = tags.map(tag => ({
            key: tag.ftaId,
            value: tag.ftaId,
            text: tag.ftaLabel
        }));
        setTagOptions(formatted);
      } catch(e) {
        console.error("Failed to fetch tags", e);
      }

      setIsLoading(false);
    })();
  }, []);

  const handleSelectionChanged = () => {
    const selectedData = gridRef.current.getSelectedData();
    console.log("selected data", selectedData);
    setSelectedRows(selectedData);
    if (selectedData.length > 0) {
      setIsDownloadVisible(true);
    } else {
      setIsDownloadVisible(false);
    }
    if (selectedData.length > 0) {
      setSelectedIds(selectedData?.map((item) => item.id));
    }
  };

  const actionsMenuChange = (data) => {
    switch (data.value) {
      case 1:
        handleDownload();
        break;

      default:
        break;
    }
  };

  const handleDownload = async () => {
    const ids = selectedRows.map(r => r.id);
    if (!ids.length) return;

    try {
      if (company) {
        await addAuditRecord({
          company: company,
          action: "Work Order Details Download",
          params: ids.join(",").toString(),
          type: 5,
          module: 2,
          user: user.username,
        });
      }
    } catch (e) {
      console.error("Failed to add audit record", e);
    }

    setIsDownloading(true);
    
    try {
      const responsePromises = ids.map(id => workOrderById(id));
      const responses = await Promise.all(responsePromises);
      
      const validResponses = responses.filter(res => res && res.workOrder);

      if (!validResponses || !validResponses.length) {
        setIsDownloading(false);
        return;
      }

      // ✅ Manual header mapping
      const headerMap = {
        fwoCode: "Work Order Number",
        fwoVehicleNumber: "Vehicle Number",
        fwoReason: "Reason for Repair",
        fwoScheduledStatrtTime: "Scheduled Start Date & Time",
        fwoActualStatrtDate: "Actual Start Date",
        fwoStartOdometer: "Start Odometer",
        fwoCompletionOdometer: "Completion Odometer",
        fwoExpectedCompletionDate: "Expected Completion Date",
        fwoActualCompletionDate: "Actual Completion Date",
        fwoRepairPriorityValue: "Repair Priority",
        fwoStatusValue: "Status",
        createdBy: "Created By",
        createdDate: "Created Date"
      };

      const keys = Object.keys(headerMap);
      const headers = keys.map((key) => headerMap[key]);

      const csvRows = [];

      // ✅ Add custom header row
      csvRows.push(headers.join(","));

      // ✅ Add data rows
      validResponses.forEach((res) => {
        const row = res.workOrder || {};
        const values = keys.map((key) => {
          let cell = row[key];

          const dateFields = [
            "fwoScheduledStatrtTime",
            "fwoActualStatrtDate",
            "fwoExpectedCompletionDate",
            "fwoActualCompletionDate",
            "createdDate",
          ];

          if (cell && dateFields.includes(key)) {
            cell = formatCsvDate(cell);
          }
          cell = cell ?? "";
          cell = cell.toString().replace(/"/g, '""'); // Escape quotes
          return `"${cell}"`;
        });
        csvRows.push(values.join(","));
      });

      const csvString = csvRows.join("\n");
      const blob = new Blob([csvString], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = "Selected_Work_Orders.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

    } catch (e) {
      console.error("Failed to download", e);
      toast.error("Failed to download Work Orders", { containerId: "Main" });
    } finally {
      setSelectedIds([]);
      setIsDownloading(false);
    }
  };

  const handleSearch = async (e) => {
    setActiveAccordion1(false);
    setResetVisible(true);
    setSearchClicked(true);
    setIsSearchResultsPending(true);
    e.preventDefault();

    try {
      const response = await searchWorkOrderData({
        company: company,
        user: user.username,
        workOrderNumber,
        vehicleNumber,
        fromDate: fromDate,
        toDate: toDate,
        status,
        active,
        labels,
      });

      setIsSearchResultsPending(false);
      setSearchResults(response);
    } catch (e) {
      console.error(e);
    }
    setSearchClicked(true);
    setIsSearchResultsPending(false);
  };

  const handleReset = () => {
    setWorkOrderNumber("");
    setVehicleNumber("");
    const aWeekAgo = new Date();
    aWeekAgo.setDate(aWeekAgo.getDate() - 7);
    const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
    const formattedToday = new Date().toISOString().split("T")[0];
    setFromDate(formattedWeekAgo);
    setToDate(formattedToday);
    setStatus("");
    setActive("");
    setLabels([]);

    setCompany(userCompany ? userCompany.comId : null);
    setSearchClicked(false);
    setSearchResults([]);
    setActiveAccordion1(true);
  };
  const getActionMenuOptions = () => {
    const actionMenuOptions = [
      {
        key: 1,
        text: "Download Details",
        value: 1,
      },

    ];
    return actionMenuOptions;
  }

  const handleDrawerClose = () => {
    setEditMode(false);
    setIsDrawerOpen(false);
  };

  const handleDrawerOpen = () => {
    dispatch(errorActions.clearWorkOrderError());
    setEditMode(false);
    setEditWorkOrder(null);
    setIsDrawerOpen(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const workOrderData = workOrderRef.current.getData();
    console.log("workOrderData",workOrderData)
    try {
      setIsSubmitLoading(true);
      dispatch(errorActions.clearWorkOrderError());

      const workOrderErrors = workOrderCreationValidation(workOrderData);
      if (Object.keys(workOrderErrors).length > 0) {
        dispatch(
            errorActions.validateWorkOrder({ workOrderData: workOrderData })
        );
        setIsSubmitLoading(false);
        toast.error("There was an error adding Work Order", {
          autoClose: 5000,
          containerId: "Main",
        });
        return;
      }
      const { issues, ...fwoData } = workOrderData;
      console.log("issues",issues)
      console.log("issues.length",issues.length)
      const hasActiveIssues = issues.some(issue => issue.fwiActive !== 2);

      if (!hasActiveIssues) {
        dispatch(
            errorActions.addWorkOrderErrorObject({
              form: "workOrderErrors",
              errors: { issues: "Cannot Add Work Order Without Issues" },
            }),
        );
        toast.error("Cannot Add Work Order Without Issues", {
          autoClose: 5000,
          containerId: "Main",
        });
        setIsSubmitLoading(false);
        return;
      }

      const hasIssueWithoutVendors = issues.some(
          (issue) => !issue.fwiVendors || issue.fwiVendors.length < 1
      );

      if (hasIssueWithoutVendors) {
        dispatch(
            errorActions.addWorkOrderErrorObject({
              form: "workOrderErrors",
              errors: { issues: "Each issue must have at least one vendor" },
            })
        );

        toast.error("Each issue must have at least one vendor", {
          autoClose: 5000,
          containerId: "Main",
        });

        setIsSubmitLoading(false);
        return;
      }

      if (fwoData.fwoStatus === 4) {
        let hasDateError = false;
        let dateErrors = {};
        
        issues.forEach((issue) => {
            if (issue.fwiActive !== 2) {
                const issueKey = issue.fwiIssue || issue.fliId;
                if (!issue.fwiStartTime) {
                    dateErrors[`issueStartTime_${issueKey}`] = "Start Date & Time is Required";
                    hasDateError = true;
                }
                if (!issue.fwiEndTime) {
                    dateErrors[`issueEndTime_${issueKey}`] = "End Date & Time is Required";
                    hasDateError = true;
                }
            }
        });

        if (hasDateError) {
          dispatch(
              errorActions.addWorkOrderErrorObject({
                form: "workOrderErrors",
                errors: dateErrors,
              })
          );

          toast.error("Each issue must have a Start Date and End Date", {
            autoClose: 5000,
            containerId: "Main",
          });

          setIsSubmitLoading(false);
          return;
        }
      }



      // Ensure we extract all needed properties safely
      const formattedIssues = (issues || []).map((issue) => {
        return {
          fwiWorkOrder: fwoData.fwoId || null,
          fwiIssue: issue.fwiIssue || issue.fliId, // Fallback to fliId if fwiIssue missing
          fwiVendor: issue.fwiVendor || {},
          fwiVendors: issue.fwiVendors || [],
          ...(issue.fwiId ? { fwiId: issue.fwiId } : {}),
          fwiStartTime: issue.fwiStartTime ?? null,
          fwiEndTime: issue.fwiEndTime ?? null,
          fwiStatus: issue.fwiStatus ?? 2,
          fwiActive: issue.fwiActive ?? 1
        };
      });

      const payload = {
        workOrder: { ...fwoData },
        issues: formattedIssues,
        author: user.username,
      };
      
      console.log("Submit Payload:", JSON.stringify(payload, null, 2));
      let response;
      if (editMode) {
        response = await updateWorkOrder(payload);
      } else {
        response = await addWorkOrder(payload);
      }

      if (response && response.status !== 400 && response.status !== 500) {
        // ── Upload queued documents (if any) ─────────────────────────────
        try {
          const pendingDocs = workOrderRef.current.getPendingDocuments?.() || {};
          const hasPendingDocs = Object.keys(pendingDocs).some(
            (key) => (pendingDocs[key] || []).length > 0
          );

          if (hasPendingDocs) {
            // Re-fetch the saved WO to get real fwivId values for every vendor
            const savedId = response?.data?.id ?? response?.data?.fwoId ?? woId;
            const savedWo = savedId ? await workOrderById(savedId) : null;

            // Build map: "issueKey_vendorId" → fwivId
            const vendorKeyToFwivId = {};
            if (savedWo?.issues) {
              for (const issue of savedWo.issues) {
                const issueKey = issue.fwiIssue ?? issue.issue?.fliId;
                for (const vendor of (issue.fwiVendors || [])) {
                  const vKey = `${issueKey}_${vendor.fwivVendor}`;
                  vendorKeyToFwivId[vKey] = vendor.fwivId;
                }
              }
            }

            // Upload each queued doc for its vendor
            const uploadErrors = [];
            for (const [vendorKey, docs] of Object.entries(pendingDocs)) {
              if (!docs || docs.length === 0) continue;
              const fwivId = vendorKeyToFwivId[vendorKey];
              if (!fwivId) {
                console.warn(`No fwivId found for vendorKey: ${vendorKey}, skipping doc upload.`);
                continue;
              }
              for (const doc of docs) {
                try {
                  const { file, ...rest } = doc;
                  const fd = new FormData();
                  fd.append("multipartFile", file);
                  fd.append("documentRequest", JSON.stringify({ ...rest, docReference: fwivId }));
                  fd.append("isImage", rest.docCategory === 1);
                  await addAndUpload(fd);
                } catch (docErr) {
                  console.error("Doc upload failed for vendor key:", vendorKey, docErr);
                  uploadErrors.push(vendorKey);
                }
              }
            }

            if (uploadErrors.length > 0) {
              toast.warn(
                `Work Order saved, but document upload failed for ${uploadErrors.length} vendor(s). Please re-upload in edit mode.`,
                { containerId: "Main", autoClose: 7000 }
              );
            }
          }
        } catch (docUploadErr) {
          console.error("Document upload step failed:", docUploadErr);
          toast.warn("Work Order saved, but document upload encountered an error. Please re-upload in edit mode.", {
            containerId: "Main",
            autoClose: 7000,
          });
        }
        // ─────────────────────────────────────────────────────────────────

        toast.success(String(response?.data?.message || `Work Order ${editMode ? 'updated' : 'added'} successfully`), { containerId: "Main" });
        handleDrawerClose();
      } else {
        toast.error(String(response?.data?.message || `Error ${editMode ? 'updating' : 'adding'} Work Order`), { containerId: "Main" });
      }
      await handleSearch(e);

    } catch (error) {
       // Defensively ensure we don't pass an object to toast
      const errorMsg = error?.response?.data?.message || error?.message || "Failed to submit Work Order";
      toast.error(String(errorMsg), { containerId: "Main" });
      console.error(error);
    } finally {
      setIsSubmitLoading(false);
    }
  };
  return (
      <div>
        <div
            className="ui tabular attached"
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
        >
          <div className="ui tabular menu top attached">
            <Tab
                Icon={FaSearch}
                onClick={() => {
                  setTab(1);
                }}
                active={tab === 1}
                label="Search"
            />
          </div>
          <Button
              label={"New"}
              Icon={Plus}
              template="drawerOpen"
              onClick={handleDrawerOpen}
              authenticated={true}
              form={FORMS.FLEET_WORK_ORDER.WORK_ORDER.form}
              module={MODULES.Fleet}
              editMode={false}
          />
        </div>

        <div
            className="ui bottom attached active tab segment"
            style={{ display: tab === 1 ? "block" : "none", width: "100%" }}
        >
          <div
              className="ui styled accordion"
              style={{ width: "100%", marginBottom: "10px" }}
          >
            <div
                className={`title ${activeAccordion1 ? "active" : ""}`}
                onClick={() => handleAccordionClick1(!activeAccordion1)}
            >
              <div>
                Click here to search
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className="dropdown icon"></i>
              </div>
            </div>
            <div className={`content ${activeAccordion1 ? "active" : ""}`}>
              {isLoading ? (
                  <LoadingSpinner />
              ) : (
                  <form className="ui form">
                    <h4 className="ui dividing header">Information</h4>

                    <div className="four fields">
                      <Input
                          label="Work Order Code"
                          type="text"
                          name="workorderNumber"
                          value={workOrderNumber}
                          onChange={(e) => setWorkOrderNumber(e.target.value)}
                      />
                      <SearchDropdown
                          label="Vehicle"
                          module={MODULES.Fleet}
                          form={FORM}
                          editMode={editMode}
                          clearable={true}
                          api={getOtherRefSearchDropdown}
                          apiDependency={{ type: "vehicle" }}
                          returnFullObject={true}
                          onResultSelect={(data) =>
                              setVehicleNumber(
                                data.value
                              )
                          }
                          onClear={() => {
                            setVehicleNumber(
                                null
                            )
                          }}
                          reset={searchReset}
                          setReset={setSearchReset}
                      />
                      <Input
                          label="From Date"
                          type="date"
                          name="fromDate"
                          value={fromDate}
                          onChange={(e) => setFromDate(e.target.value)}
                      />
                      <Input
                          label="To Date"
                          type="date"
                          name="toDate"
                          value={toDate}
                          onChange={(e) => setToDate(e.target.value)}
                      />
                    </div>

                    <div className="four fields">

                      <Dropdown
                          clearable
                          options={statusOpt}
                          placeholder="Status"
                          label="Status"
                          value={status}
                          onChange={(e, data) => setStatus(data.value)}
                      />
                      <Dropdown
                          clearable
                          options={activeOpt}
                          placeholder="Active"
                          label="Active"
                          value={active}
                          onChange={(e, data) => setActive(data.value)}
                      />
                      <Dropdown
                          label="Labels"
                          placeholder="Select Tags"
                          fluid
                          multiple
                          search
                          selection
                          clearable
                          options={tagOptions}
                          value={labels}
                          onChange={(e, data) => setLabels(data.value)}
                          style={{
                              minHeight: "38px",
                              height: "auto",
                              display: "flex",
                              alignItems: "flex-start",
                              flexWrap: "wrap"
                          }}
                      />
                    </div>

                    <div
                        style={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                    >
                      <div className="field" style={{ width: "100%" }}>
                        <Button
                            template="search"
                            onClick={handleSearch}
                        />
                        <Button
                            template="searchReset"
                            onClick={handleReset}
                        />
                      </div>
                    </div>
                  </form>
              )}
            </div>
          </div>

          {searchClicked && (
              <>
                {isSearchResultsPending ? (
                    <LoadingSpinner />
                ) : (
                    <Grid
                        isLoading={isSearchResultsPending}
                        autoHeight={true}
                        searchable={true}
                        // showDownloadButton={true}
                        // downloadParam={""}
                        // downloadAction="Work Order Excel Download"
                        // downloadOnlySelected={false}
                        // excelSheetDownload={true}
                        // vrScroll={true}
                        // multiRowSelection={true}
                        // onSelectionChanged={handleSelectionChanged}
                        // rowSelection="multiple"
                        // handleActionMenuChange={actionsMenuChange}
                        // showActionMenu={selectedRows.length > 0}
                        // actionMenuOptions={getActionMenuOptions()}
                        // showDownloadButton={true}
                        // multiRowSelection={true}
                        // downloadParam={""}
                        // downloadAction="Work Order CSV Download"
                        // reportName={"Work Order Records.csv"}
                        multiRowSelection={true}
                        onSelectionChanged={(e) => {
                          setSelectedRows(e.api.getSelectedRows());
                        }}
                        showActionMenu={selectedRows.length > 0}
                        actionMenuOptions={getActionMenuOptions()}
                        handleActionMenuChange={actionsMenuChange}

                        config={[
                          {
                            headerName: "Id",
                            field: "id",
                            sort: "desc",
                            hide: true,
                          },
                          {
                            headerName: "Workorder Number",
                            field: "code",
                            width: 180,
                            cellRenderer: ResizableScrollingTextRenderer,
                            pinned: "left",
                            filter: true,
                            checkboxSelection: true,
                            headerCheckboxSelection: true,
                          },
                          {
                            headerName: "Vehicle Number",
                            field: "vehicleNo",
                            width: 180,
                            cellRenderer: ResizableScrollingTextRenderer,
                          },
                          {
                            headerName: "Issue No",
                            field: "issueCode",
                            width: 180,
                            cellRenderer: ResizableScrollingTextRenderer,
                          },
                          {
                            headerName: "Expected Completion Date",
                            field: "expectedCompletionDate",
                            cellRenderer: DateTimeCellRenderer,
                          },
                          {
                            headerName: "Status",
                            field: "status",
                            width: 180,
                            cellRenderer: IssueStatusCellStyle,
                          },
                          {
                            headerName: "Action",
                            field: "active",
                            width: 180,
                            cellRenderer: ActiveCellStyle,
                          },
                          {
                            headerName: "Created By",
                            field: "createdBy",
                            width: 180,
                            cellRenderer: ResizableScrollingTextRenderer,
                          },
                        ]}
                        content={searchResults}
                        ref={gridRef}
                        onCellDoubleClicked={async(props) => {
                          if (props.colDef.field === "status") {
                            setSelectedStatusData(props.data);
                            statusModalRef.current?.showModal();
                          } else {
                            setIsLoading(true);
                            const response = await workOrderById(props.data.id);
                            setEditWorkOrder(response);
                            setWoCode(props.data.code);
                            setWoId(props.data.id);
                            setEditMode(true);
                            setIsLoading(false);
                            dispatch(errorActions.clearWorkOrderError());
                            setIsDrawerOpen(true);
                            console.log("edit issueList",response)
                          }
                        }}
                    />
                )}
              </>
          )}
        </div>

        <SideDrawer
            open={isDrawerOpen}
            handleDrawerClose={handleDrawerClose}
            head={

              editMode ? (
                  <div
                      className="blacklist-code-header"
                      style={{ padding: "10px 16px", borderBottom: "1px solid #ccc" }}
                  >
                    <h3>Work Order Code: {editWorkOrder?.workOrder?.fwoCode}</h3>
                  </div>
              ) : null
            }
            body={
              <form className="drawer-content" onSubmit={handleSubmit}>
                <div style={{ width: "60vw", boxShadow: "none" }}>
                  <div className="ui top attached tabular menu">
                    <div
                        className={`item ${drawerTab === 1 ? "active" : ""}`}
                        onClick={() => {
                          setDrawerTab(1);
                        }}
                    >
                  <span>
                    <FileText
                        size={15}
                        style={{
                          marginRight: "5px",
                          // color: `${
                          //     Object.keys(errorState.deductMasterErrors).length !==
                          //     0
                          //         ? "#e0b4b4"
                          //         : ""
                          // }`,
                        }}
                    />
                  </span>
                      <label
                          style={{
                            // color: `${
                            //     Object.keys(errorState.deductMasterErrors).length !== 0
                            //         ? "#e0b4b4"
                            //         : ""
                            // }`,
                          }}
                      >
                        Work Order
                      </label>
                    </div>
                  </div>

                  <div
                      className="ui bottom attached active tab segment"
                      style={{ display: drawerTab === 1 ? "block" : "none" }}
                  >
                    <WorkOrderForm
                        editMode={editMode}
                        handleDrawerClose={handleDrawerClose}
                        isLoading={isLoading}
                        errors={errorState.workOrderErrors}
                        currentValues={editMode ? editWorkOrder: null}
                        ref={workOrderRef}
                    />
                  </div>

                  <div
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                      }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {editMode ? (
                          <Button
                              type="submit"
                              template="create"
                              isLoading={isSubmitLoading}
                              create={!editMode}
                              form={FORMS.FLEET_WORK_ORDER.WORK_ORDER.form}
                              module={MODULES.Fleet}
                              section={FORMS.FLEET}
                              disabled={(editWorkOrder?.workOrder?.fwoStatus === 3 && !closePermission) || editWorkOrder?.workOrder?.fwoStatus === 4}
                              authenticated={true}
                          />
                      ) : drawerTab === 1 && !isLoading ? (
                          <Button
                              type="submit"
                              template="create"
                              isLoading={isSubmitLoading}
                              create={!editMode}
                              form={FORMS.FLEET_WORK_ORDER.WORK_ORDER.form}
                              module={MODULES.Fleet}
                              section={FORMS.FLEET}
                              authenticated={true}
                          />
                      ) : (
                          ""
                      )}
                    </div>
                  </div>
                </div>
              </form>
            }
            style={{ width: "60vw", boxShadow: "none" }}

        />
        <Modal 
          ref={statusModalRef} 
          header="Status History"
          onCloseCleanUp={() => setSelectedStatusData(null)}
        >
          {selectedStatusData && (
            <WorkOrderStatusManagement
              referenceId={selectedStatusData.id}
              referenceCode={selectedStatusData.code}
              close={() => {
                statusModalRef.current?.close();
                setSelectedStatusData(null);
              }}
            />
          )}
        </Modal>
      </div>
  );
};

export default WorkOrder;
